import { apiClient } from "../../utils/apiClient";
import { RolePermission } from "../../types/rolePermission";

export const fetchRolePermissions = async(): Promise<RolePermission[]> => {
    const response = await apiClient.get('/rolePermissions');
    return response.data;
};

export const upsertRolePermission = async (rolePermission: RolePermission): Promise<RolePermission> => {
    const response = await apiClient.post('/rolePermissions', rolePermission);
    return response.data;
};

export const checkIfRolePermissionExists = async (role_id: number, permission_id: number): Promise<boolean> => {
    const response = await apiClient.get(`/rolePermissions/checkRolePermissionExists/${role_id}/${permission_id}`);
    return response.data.exists;
};
